import { FC, useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { LayoutSplashScreen } from 'src/app/layout';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { fetchParameterItem } from '../../../network/parameterCrud';
import { ParameterItem } from '../../../types/parameter-setting';
import { fetchCriteriaResultList } from '../../../network/criteriaCrud';
import { CriteriaListItem } from '../../../types/criteria-setting';
import ParameterSettingForm from './components/ParameterSettingForm';

const ParameterSettingDetailPage: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [parameterDetail, setParameterDetail] = useState<ParameterItem>();
  const [criteriaList, setCriteriaList] = useState<CriteriaListItem[]>([]);

  const reloadCriteriaList = async (type: string) => {
    try {
      const res = await fetchCriteriaResultList({ isGetAll: true, type }, [], dispatch);
      setCriteriaList(res?.items || []);
    } catch (err) {}
  };

  const reloadData = async () => {
    setIsLoading(true);
    try {
      if (id) {
        const result = await fetchParameterItem(id, dispatch);
        if (result) {
          setParameterDetail(result);
          await reloadCriteriaList(result.type);
        }
      }
    } catch (error: any) {
      history.push(NOT_FOUND_ERROR_PAGE_PATH);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    reloadData();
  }, [id]);

  return (
    <>
      {isLoading || !parameterDetail ? (
        <LayoutSplashScreen />
      ) : (
        <ParameterSettingForm
          id={id}
          criteriaList={criteriaList}
          parameterDetail={parameterDetail}
          onRouteTo={(route: any) => history.push(route)}
        />
      )}
    </>
  );
};

export default ParameterSettingDetailPage;
